import "./BulkTestOrderSessionListComponent.scss";
import {ITableColumn} from "../../../shared/models/table.model";
import React, {useEffect, useState} from "react";
import {APIConfig} from "../../../constants";
import TableWrapperV2Component
    from "../../../shared/components/table-components/table-wrapper-v2/TableWrapperV2Component";
import commonService from "../../../shared/services/common.service";

interface BulkTestOrderSessionListComponentProps {
    dataColumns: any[];
    bulkOrderID: any;
}

const BulkTestOrderSessionListComponent = (props: BulkTestOrderSessionListComponentProps) => {
    const {bulkOrderID, dataColumns} = props;
    const [finalColumns, setFinalColumns] = React.useState<ITableColumn[]>([]);

    const [columns] = useState<ITableColumn[]>([
        {
            id: 'barcode', label: 'Accession ID', isDefaultColumn: true, align: 'center', fixed: 'left',
        },

        {
            id: 'patientDetails.firstName', label: 'First Name', isDefaultColumn: true,
            content: (item: any) => (
                <>
                    {item?.patientDetails?.firstName ? commonService.capitalizeFirstLetterOfEachWord(item?.patientDetails?.firstName) : '-'}
                </>
            )
        },

        {
            id: 'patientDetails.lastName', label: 'Last Name', isDefaultColumn: true,
            content: (item: any) => (
                <>
                    {item?.patientDetails?.lastName ? commonService.capitalizeFirstLetterOfEachWord(item?.patientDetails?.lastName) : '-'}
                </>
            )
        },
        {
            id: 'dateOfBirth', label: 'Date of Birth', align: 'center',
            isDefaultColumn: true,
            content: (item: any) => (
                <>
                    {item?.patientDetails?.dateOfBirth}
                </>
            )
        },

        {
            id: 'dateOfCollection', label: 'Date of Collection', align: 'center',
            isDefaultColumn: false,
            content: (item: any) => (
                <>
                    {
                        item?.dateOfCollection ? <>
                            {commonService.formatDate(item?.dateOfCollection)}
                        </> : <> - </>
                    }
                </>
            )
        },

        {
            id: 'TimeOfCollection', label: 'Time of Collection', align: 'center',
            isDefaultColumn: false,
            content: (item: any) => (
                <>
                    {
                        item?.timeOfCollection ? <>
                            {item?.timeOfCollection.slice(0, 5)}
                        </> : <> - </>
                    }
                </>
            )
        },

        {
            id: 'isPriorityOrder',
            label: 'Order Prioritization Request',
            isDefaultColumn: true,
            align: 'center',
            width: '210',
            content: (item: any) => (
                <>
                    {item.isPriorityOrder ? 'Yes' : 'No'}
                </>
            )
        },

        {
            id: 'sendResultToPatient', label: 'Send Result to Patient', isDefaultColumn: true,width:250, align: 'center',
            content: (item: any) => (
                <>
                    {item.sendResultToPatient ? 'Yes' : 'No'}
                </>
            )
        },

        {
            id: 'patientIntakeForm', label: 'Patient Intake Form', isDefaultColumn: true, align: 'center',
            content: (item: any) => (
                <>
                    {item.patientIntakeForm ? 'Yes' : 'No'}
                </>
            )
        },

        {
            id: 'modeOfPayment', label: 'Mode of Payment', isDefaultColumn: true, align: 'center',
            content: (item: any) => (
                <>
                    {item.modeOfPayment ? commonService.capitalizeFirstLetterOfEachWord(item?.modeOfPayment) : '-'}
                </>
            )
        },

        {
            id: 'status', label: 'Status', isDefaultColumn: true, width: '150', align: 'center', fixed: 'right',
            content: (item: any) => (
                <>
                    {item.status || '-'}
                </>
            )
        },

    ]);

    useEffect(() => {

        const finalColumns = columns.filter((column: ITableColumn) => {
            if (column.label.endsWith('*')) {
                column.label = column.label.slice(0, -1);
            }
            // eslint-disable-next-line array-callback-return
            return dataColumns.find((dataColumn: any) => {
                const columnLabel = dataColumn.endsWith('*') ? dataColumn.slice(0, -1) : dataColumn;
                if (column.label === columnLabel) {
                    return column;
                }
            })
        });
        setFinalColumns(finalColumns);

    }, [dataColumns, columns]);


    return (
        <div className={'bulk-test-order-session-list-component table-list-container'}>
            <TableWrapperV2Component
                isPaginated={true}
                columns={finalColumns}
                url={APIConfig.BULK_ORDER_SESSION_LIST.URL(bulkOrderID)}
                method={APIConfig.BULK_ORDER_SESSION_LIST.METHOD}
                isHoverable={true}
                isStickyHeader={true}
                isColumnFilterVisible={true}
            />
        </div>
    );

};

export default BulkTestOrderSessionListComponent;
